import { c as _c } from "react/compiler-runtime";
import { DatadogRumWrapper } from '@newfront-insurance/dd-rum';
import type { AuthProviderContext, AuthProviderProps } from '@newfront-insurance/next-auth';
import type { Provider } from '@newfront-insurance/react-provision';
import * as React from 'react';
import type { JSX } from 'react';
interface Props {
  children: React.ReactNode;
  authProvider: Provider<AuthProviderContext, AuthProviderProps>;
}
export function DatadogWrapper(t0) {
  const $ = _c(3);
  const {
    children,
    authProvider
  } = t0;
  const t1 = children as JSX.Element;
  let t2;
  if ($[0] !== authProvider || $[1] !== t1) {
    t2 = <DatadogRumWrapper authProvider={authProvider}>{t1}</DatadogRumWrapper>;
    $[0] = authProvider;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}